export default "__VITE_ASSET__BYGHyM68__"